module.exports = __webpack_public_path__ + "img/privilege5.fa316d33.png";